module.exports = __webpack_public_path__ + "img/load.08fc9b56.gif";